import {
  Flex,
  Image,
  Modal,
  Pagination,
  Paper,
  Stack,
  Table,
  Text,
  UnstyledButton
} from '@mantine/core'
import { ReactNode, useState } from 'react'
import { CopyableText } from '@/components/ui-shared/CopyableText/CopyableText'
import { getPageCount, getPageOffset } from '@/utils/pagination'
import { ExtractionString } from '../../ExtractionString/ExtractionString'
import { OcrBadge } from '../../OcrBadge/OcrBadge'

type ExtractionResult = {
  extractionString: string
  description: ReactNode
  cropPath: string
  status?: 'whitelist' | 'blacklist' | null
}

const MAX_THUMB_HEIGHT = 80
const PAGE_SIZE = 3

type ExtractionResultsProps = {
  results: ExtractionResult[]
}

export const ExtractionResults = ({ results }: ExtractionResultsProps) => {
  const [imageUrl, setImageUrl] = useState('')
  const [page, setPage] = useState(1)

  const pageResults = results
    .map((result) => ({
      ...result,
      uuid: result.extractionString + '_' + result.cropPath
    }))
    .slice(getPageOffset(page, PAGE_SIZE), page * PAGE_SIZE)

  const totalPages = getPageCount(results.length, PAGE_SIZE)

  return (
    <>
      <Table horizontalSpacing="xs" verticalSpacing="xs">
        <Table.Tbody>
          {pageResults.map((result) => (
            <Table.Tr key={result.uuid}>
              <Table.Td width="60%">
                <Stack gap="xs">
                  {result.extractionString ? (
                    <CopyableText text={result.extractionString} iconSize="sm">
                      <ExtractionString extraction={result.extractionString} />
                    </CopyableText>
                  ) : (
                    <Text size="sm">n/a</Text>
                  )}

                  <Text size="xs" c="dimmed">
                    {result.description}
                  </Text>

                  {result.status && <OcrBadge tag={result.status} />}
                </Stack>
              </Table.Td>

              <Table.Td>
                <UnstyledButton onClick={() => setImageUrl(result.cropPath)}>
                  <Image
                    h={MAX_THUMB_HEIGHT}
                    fit="contain"
                    src={result.cropPath}
                  />
                </UnstyledButton>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>

      {totalPages > 1 && (
        <Flex justify="center" py="md">
          <Pagination
            total={totalPages}
            value={page}
            withPages={false}
            onChange={setPage}
          />
        </Flex>
      )}

      <Modal size="xl" opened={imageUrl !== ''} onClose={() => setImageUrl('')}>
        {imageUrl !== '' && (
          <Paper withBorder>
            <Image h="60vh" fit="contain" src={imageUrl} />
          </Paper>
        )}
      </Modal>
    </>
  )
}
